// NEW: UI_REVAMP
import { Box, Button } from '@chakra-ui/react';
import GlassMask from '../box/GlassMask';

const VARIANTS = {
	primary: {
		bg: 'rgba(241, 242, 244, 0.5)',
		color: 'black',
	},
	red: {
		bg: 'rgba(255, 195, 195, 0.5)',
		color: 'rgba(255, 40, 40)',
	},
	blue: {
		bg: 'rgba(193, 213, 255, 0.5)',
		color: 'rgba(22, 52, 242)',
	},
};

const GlassButton = ({
	children,
	onClick,
	variant = 'primary',
	isDisabled = false,
	type = 'button',
	...props
}) => {
	const currentVariant = VARIANTS[variant] || VARIANTS.primary;
	const { bg, color } = currentVariant;

	const handleClick = isDisabled ? undefined : onClick;

	return (
		<Button
			type={type}
			position='relative'
			display='grid'
			placeItems='center'
			w='full'
			h='50px'
			borderRadius='full'
			bg={bg}
			p={0}
			overflow='hidden'
			color={color}
			onClick={handleClick}
			isDisabled={isDisabled}
			aria-disabled={isDisabled}
			opacity={isDisabled ? 0.6 : 1}
			cursor={isDisabled ? 'not-allowed' : 'pointer'}
			_hover={{ bg, color }}
			_active={{ bg, color }}
			{...props}
		>
			<GlassMask />

			<Box position='relative' zIndex={1}>
				{children}
			</Box>
		</Button>
	);
};

export default GlassButton;
